<template>
  <div class="form-horizontal">
    <div class="form-group">
      <label class="col-sm-2 control-label">颜色</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" placeholder="颜色" v-model="color.text" @input="onPhoneInput">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['color'],
  methods: {
    onPhoneInput() {
      this.$emit('onPhoneInput')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/forms/Color.vue